import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'
import Vue from 'vue'

const state = {
	active: false,

  // model
  screenModel: [],

  // form
  serviceId: null,
  serviceContentsId: null,

  // サービスコンテンツのdeviceTypeUuid
  deviceTypeId: null,

  // データ更新の判別フラグ
  updated: false
}

const getters = {
	get: state => state
}

const actions = {
	show ({commit}, {serviceId, serviceContentsId, deviceTypeId}) {
    console.log(deviceTypeId)
    commit('setServiceId', serviceId)
    commit('setServiceContentsId', serviceContentsId)
    commit('setDeviceTypeId', deviceTypeId)
    console.log(state.deviceTypeId)

		// cover
		this.dispatch('core/showModalCover')
		
		commit('showed')
	},
	hide ({commit}) {
		if (!state.active) return
		commit('hided')
		
		// cover
		setTimeout(() => {
			this.dispatch('core/hideModalCover')
		}, 350)
	},

  /**
   * 初期データを読出し
   */
  loadModel ({commit}, {screenConfigMstParams}) {
    return new Promise((resolve, reject) => {
      ApiManager.request(
        ['screenConfigMst'],
        ['v1ScreenConfigMstListGet'],
        [screenConfigMstParams])
        .then(res => {
          let status = Utility.parseResponse(res)

          if (status.result) {
            commit('setScreenModel', res[0].data.screenConfigMsts)
            console.log('screenModel', state.screenModel)
            resolve()

          } else if (status.error) {
            // エラーメッセージ表示
            reject(res)
          } else {
            // アプリケーションエラー表示
            reject(null)
          }
        })
        .catch(error => {
          // アプリケーションエラー表示
          reject(null)
        })
    })
  },

  /**
   * データ更新判別フラグの切替
   */
  setUpdated ({commit}, flag) {
    commit('setUpdated', flag)
  }
}

const mutations = {
	showed (state) {
		state.active = true
	},
	hided (state) {
    state.active = false
	},

  // model
  setScreenModel (state, data) {
    Vue.set(state, 'screenModel', data)
  },

  // form
  setServiceId (state, id) {
    state.serviceId = id
  },
  setServiceContentsId (state, id) {
    state.serviceContentsId = id
  },
  setDeviceTypeId (state, id) {
    state.deviceTypeId = id
  },
  setUpdated (state, flag) {
    state.updated = flag
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
